export class AdditionalIncome {
    constructor (
        public AdditionalIncomeAmount: number = null,
        public AdditionalIncomeSource: string = '',
        public CaRentVoucher:number =null
    ) { }
}
